import { useState } from "react";
import { AuthService } from "../../Services/authServices";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import { defaultTheme, NxField, NxButton } from "../nx";

interface IForgotPasswordModal {
    show: any,
    handleClose: any
}

const t = defaultTheme;

export default function ForgotPasswordModal({ show, handleClose }: IForgotPasswordModal) {

    const navigate = useNavigate();

    const [email, setEmail] = useState("");
    const [loading, setLoading] = useState(false);

    const handleForgotPassword = async () => {
        if (!email) {
            toast.error("Please enter your email");
            return;
        }
        setLoading(true);
        try {
            const res: any = await AuthService.forgotPassword({ email } as any);
            if (res.status === 200) {
                toast.success("OTP sent to your email");
                navigate(`/reset-password?email=${encodeURIComponent(email)}`);
            }
        } catch (err: any) {
            toast.error(err?.response?.data || "Unable to send OTP");
        } finally {
            setLoading(false);
        }
    };

    if (!show) return null;

    return (
        <div
            style={{
                position: "fixed", inset: 0, zIndex: 9999,
                background: "rgba(0,0,0,0.4)",
                display: "flex", alignItems: "center", justifyContent: "center",
                fontFamily: '"Geist", ui-sans-serif, system-ui, -apple-system, sans-serif',
            }}
            onClick={handleClose}
        >
            <div
                onClick={(e) => e.stopPropagation()}
                style={{
                    background: t.surface, borderRadius: 14, width: "90%", maxWidth: 420,
                    boxShadow: "0 20px 60px rgba(0,0,0,0.2)", overflow: "hidden",
                }}
            >
                {/* Header */}
                <div style={{
                    padding: "18px 24px", borderBottom: `1px solid ${t.border}`,
                    display: "flex", alignItems: "center", justifyContent: "space-between",
                }}>
                    <h3 style={{ margin: 0, fontSize: 16, fontWeight: 600, color: t.ink }}>Reset your password</h3>
                    <button
                        onClick={handleClose}
                        style={{
                            background: "transparent", border: `1px solid ${t.border}`, borderRadius: 6,
                            padding: "4px 12px", fontSize: 12, color: t.inkSoft, cursor: "pointer", fontFamily: "inherit",
                        }}
                    >Close</button>
                </div>

                {/* Body */}
                <div style={{ padding: 24 }}>
                    <p style={{ fontSize: 13, color: t.inkSoft, lineHeight: 1.5, margin: "0 0 18px" }}>
                        Enter your email and we'll send you an OTP to reset your password.
                    </p>
                    <NxField
                        t={t}
                        label="Email"
                        name="email"
                        type="email"
                        value={email}
                        placeholder="you@example.com"
                        onChange={(e) => setEmail(e.target.value)}
                    />
                </div>

                {/* Footer */}
                <div style={{ padding: "14px 24px", borderTop: `1px solid ${t.border}`, display: "flex", gap: 10, justifyContent: "flex-end" }}>
                    <NxButton t={t} kind="secondary" onClick={handleClose}>Cancel</NxButton>
                    <NxButton t={t} kind="primary" disabled={loading} onClick={handleForgotPassword}>
                        {loading ? "Sending..." : "Send OTP"}
                    </NxButton>
                </div>
            </div>
        </div>
    );
}
